import { Badge, Flex, Tooltip } from "@mantine/core";
import type { JSX } from "react";
import { forwardRef } from "react";
import classes from "../../chat-components.module.css";
import { type InfoBadgeType, infoBadgeConfig } from "./config/infoBadgeConfig";
import { InfoCircle } from "./icons/InfoCircle";

export interface InfoBadgeProps {
    type: InfoBadgeType;
}

export const OfferInfoBadge = forwardRef<HTMLDivElement, InfoBadgeProps>(({ type }, ref): JSX.Element => {
    const config = infoBadgeConfig[type];

    return (
        <Badge
            ref={ref}
            className={classes.info_badge}
            rightSection={
                <Tooltip
                    label={config.tooltipText}
                    multiline
                    position="bottom-start"
                    styles={{
                        tooltip: {
                            whiteSpace: "pre-line",
                        },
                    }}
                >
                    <Flex>
                        <InfoCircle />
                    </Flex>
                </Tooltip>
            }
        >
            {config.offerText}
        </Badge>
    );
});

OfferInfoBadge.displayName = "OfferInfoBadge";
